module.exports = __webpack_public_path__ + "media/images/webpage/shared/checklist/good-adc004ff187f3e86f5dba96bab4595a7.svg";